/**
 * Tracks the user's dev-nest SESSION start per origin, so the splash's "last
 * login" reflects when they actually opened the app here — not the JWT
 * `auth_time` claim, which the hosted-UI single sign-on freezes at the original
 * interactive login and shares across /ops + /analytics (it would read e.g.
 * "Jun 3" forever while a persistent web session just refreshes its token).
 *
 * recordLogin() runs on every authenticated load (completeAuth + restoreSession).
 * It keeps the current SESSION start and a SEEN heartbeat; a gap of more than
 * GAP_MS since the last activity counts as a new session and resets the start.
 * localStorage is per-origin, so it is scoped to "this URL, this user".
 */
const SESSION = 'phenom.nest.session.'
const SEEN = 'phenom.nest.seen.'
const GAP_MS = 20 * 60 * 1000 // a >20-min gap since last activity = a new session

export function recordLogin(sub: string | undefined): void {
  if (!sub || typeof window === 'undefined') return
  try {
    const ls = window.localStorage
    const now = Date.now()
    const seen = Number(ls.getItem(SEEN + sub)) || 0
    const start = Number(ls.getItem(SESSION + sub)) || 0
    if (!start || now - seen > GAP_MS) ls.setItem(SESSION + sub, String(now))
    ls.setItem(SEEN + sub, String(now))
  } catch {
    /* storage unavailable — non-fatal */
  }
}

/**
 * The start of the user's current dev-nest session on this origin, in UNIX
 * SECONDS (the unit the splash's relTime expects), or undefined if none recorded.
 */
export function lastLoginSeconds(sub: string | undefined): number | undefined {
  if (!sub || typeof window === 'undefined') return undefined
  try {
    const ms = Number(window.localStorage.getItem(SESSION + sub))
    return Number.isFinite(ms) && ms > 0 ? Math.floor(ms / 1000) : undefined
  } catch {
    return undefined
  }
}
